import { siteConfig } from "../config/siteData";
import logo from "../images/logo.png";

const Hero = () => {



  return (
    <section
      id="home"
      className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-black/20"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20">
        <div className="text-center">
          <div className="mb-8">
            <div className="mx-auto mb-6 flex items-center justify-center">
              <img src={logo} alt="The Kitchen Logo" className="w-72" />
            </div>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6">
            <span className="text-purple-400">THE KITCHEN</span>
            <br />
            <span className="text-3xl md:text-4xl font-semibold">
              Hip-Hop Dance Company
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto">
            {siteConfig.tagline}
          </p>

          <div className="text-lg md:text-xl text-teal-400 font-semibold mb-12 uppercase tracking-wide">
            {siteConfig.brandPositioning}
          </div>

          <button
            onClick={() => {
              const element = document.getElementById("contact");
              if (element) {
                const offsetTop = element.offsetTop - 80;
                window.scrollTo({
                  top: offsetTop,
                  behavior: "smooth",
                });
              }
            }}
            className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-4 rounded-lg text-xl font-bold transition-all duration-300 transform hover:scale-105 shadow-2xl"
          >
            JOIN THE KITCHEN
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
